// extracted by mini-css-extract-plugin
export var boxHead = "posts-navigation-module--boxHead--3QVBv";
export var boxLink = "posts-navigation-module--boxLink--2wEtD";
export var nextBox = "posts-navigation-module--nextBox--3GKVf";
export var postsNavigation = "posts-navigation-module--postsNavigation--1SeMk";
export var prevBox = "posts-navigation-module--prevBox--2WQvl";